import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel } from "@faire/retailer-visitor-shared/components/Carousel/Carousel";
import { CarouselWithTitleShell } from "@faire/retailer-visitor-shared/components/Carousel/CarouselWithTitleShell";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
var StyledCarousel = styled(Carousel).withConfig({
    componentId: "sc-7085f669-0"
})([
    "grid-area:carousel;overflow:hidden;padding:0;",
    "{padding:0;overflow:unset;}"
], responsiveMediaQueries.tabletAndAbove);
export var CarouselWithTitle = function(_param) {
    var className = _param.className, title = _param.title, titleRight = _param.titleRight, leftAlignTitle = _param.leftAlignTitle, subtitle = _param.subtitle, seeAllLink = _param.seeAllLink, seeAllOnClick = _param.seeAllOnClick, dataTestId = _param.dataTestId, header = _param.header, increaseMobileRowSpacing = _param.increaseMobileRowSpacing, noLeftTitlePadding = _param.noLeftTitlePadding, titleTypography = _param.titleTypography, innerRef = _param.innerRef, rest = _object_without_properties(_param, [
        "className",
        "title",
        "titleRight",
        "leftAlignTitle",
        "subtitle",
        "seeAllLink",
        "seeAllOnClick",
        "dataTestId",
        "header",
        "increaseMobileRowSpacing",
        "noLeftTitlePadding",
        "titleTypography",
        "innerRef"
    ]);
    var TypedCarousel = StyledCarousel;
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsx(CarouselWithTitleShell, {
        innerRef: innerRef,
        className: className,
        title: title,
        titleRight: titleRight,
        leftAlignTitle: leftAlignTitle,
        subtitle: subtitle,
        seeAllLink: seeAllLink,
        seeAllOnClick: seeAllOnClick,
        dataTestId: dataTestId,
        header: header,
        increaseMobileRowSpacing: increaseMobileRowSpacing,
        noLeftTitlePadding: noLeftTitlePadding,
        titleTypography: titleTypography,
        children: /*#__PURE__*/ _jsx(TypedCarousel, _object_spread_props(_object_spread({}, rest), {
            noWrap: isMobile || rest.useHorizontalScrollCarousel || rest.noWrap,
            itemGap: rest.itemGap
        }))
    });
};
CarouselWithTitle.Container = CarouselWithTitleShell.Container;
CarouselWithTitle.Title = CarouselWithTitleShell.Title;
CarouselWithTitle.AuxiliaryTitle = CarouselWithTitleShell.AuxiliaryTitle;
CarouselWithTitle.Content = StyledCarousel;
